<template>
    <div :class="['base-button',{'disabled': disabled},{'focus': focus}]"
         :style="[
                    {'backgroundColor': background},
                    {'color': color},
                    {'padding': padding},
                    {'font-size': size+'px'},
                    {'gap': gap+'px'},
                    {'min-height': minHeight+'px'},
                    {'min-width': minWidth+'px'},
                 ]"
         :data-text="searchLoaderStatus ? '' : localizeList.noSvgSearch"
         @click="click($event)">
        <div class="hover-effect"></div>
        <slot></slot>
    </div>
</template>

<script>

    export default {
        name: "base-button",
        data() {
            return {
                focus:false
            }
        },
        props: {
            searchLoaderStatus: {
                type: Boolean,
                default: false
            },
            background: {
                type: String,
                default: "var(--primary-color)"
            },
            color: {
                type: String,
                default: "var(--white-color)"
            },
            size: {
                type: [String, Number],
                default: 16
            },
            padding: {
                type: String,
                default: "10px"
            },
            gap: {
                type: String,
                default: "0"
            },
            minHeight: {
                type: String,
                default: "0"
            },
            minWidth: {
                type: String,
                default: "0"
            },
            disabled: {
                type: Boolean,
                default: false
            },
            parentFocus: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            click(e) {
                if (!this.disabled) {
                    this.$emit("click", e)
                }
            }
        },
        watch:{
            parentFocus(val){
                this.focus=val;
            }
        }
    }
</script>

<style scoped>
    .base-button {
        position: relative;
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all .2s;
    }
    .base-button.focus{
        outline: 2px solid black;
    }
    .base-button .hover-effect {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #000;
        border-radius: 3px;
        cursor: pointer;
        transition: all .2s;
        z-index: 1;
        opacity: 0;
    }
    .base-button.disabled,
    .base-button.disabled:hover{
        filter: brightness(130%);
        cursor: default;
        pointer-events: none;
    }
    .base-button.disabled .hover-effect,
    .base-button.disabled:hover{
        cursor: default
    }
    .base-button:hover .hover-effect {
        opacity: 0.1;
    }
    .base-button.disabled:hover .hover-effect {
        opacity: 0;
    }
</style>
